import { ref, watch } from 'vue'
import { defineStore } from 'pinia'
import type { IBridgeDeytail } from '@/apiFzn/types'
import { getBridgeDataDetail } from '@/apiFzn'

import { getMarkDetail } from '@/apiFzn'
import type { ImarkDetail } from '@/apiFzn/types'

/**桥梁数据 */
export const useMarkStore = defineStore('mark', () => {
  // 状态
  const markId = ref<number>()
  const showMarkDetail = ref(false)
  const markDetail = ref<ImarkDetail>()
  // 航标图片
  const previewPhoto = ref<string[]>()
  // 方法
  const openMarkDetail = async (id: number) => {
    markId.value = id
    showMarkDetail.value = true
    await loadMarkDetail()
  }

  const closeDetail = () => {
    showMarkDetail.value = false
    markId.value = undefined
    markDetail.value = undefined
  }

  // 私有方法
  const loadMarkDetail = async () => {
    if (!markId.value) return
    try {
      const res = await getMarkDetail({ id: markId.value })
      markDetail.value = res.data
      previewPhoto.value = markDetail.value.photo.split(',').map((url) => url.trim())
    } catch (error) {
      console.error('获取航标失败:', error)
    }
  }

  return {
    // 状态
    markId,
    previewPhoto,
    showMarkDetail,
    markDetail,
    // 方法
    openMarkDetail,
    closeDetail,
  }
})
